"use client";
import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { GiHamburgerMenu } from "react-icons/gi";
import Drawer from "react-modern-drawer";
// import { useRouter } from "next/navigation";
import classes from "./SideBarSkeleton.module.css";

import { useNavigate } from "react-router-dom";
import { isMobileViewHook } from "../../../resources/customHooks/isMobileViewHook";
import Sidebar from "../../molecules/SideBar";
import Header from "../../organisms/Header";
// import { BUSINESS_NAV_DATA } from "@/data/app-data";

const SideBarSkeleton = ({
  heading,
  children,
  stats,
  searchText,
  setSearchText,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      isMobileViewHook(setIsMobile, 1025);
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <Container fluid className="g-0">
      <Row className="g-0">
        <div className={[!isMobile && classes.sidebarDiv].join(" ")}>
          {!isMobile ? (
            <Sidebar />
          ) : (
            <Drawer
              open={isOpen}
              onClose={toggleDrawer}
              direction="left"
              className="drawerContainer"
            >
              <Sidebar />
            </Drawer>
          )}
        </div>
        <div className={[!isMobile && classes.contentDiv].join(" ")}>
          {/* {isMobile && (
            <GiHamburgerMenu
              className={classes.GiHamburgerMenu}
              onClick={toggleDrawer}
            />
          )} */}
          <Header
            heading={heading}
            stats={stats}
            searchText={searchText}
            setSearchText={setSearchText}
            isMobile={isMobile}
            toggleDrawer={toggleDrawer}
          />

          <div className={classes.childDiv}>{children}</div>
        </div>
      </Row>
    </Container>
  );
};

export default SideBarSkeleton;
